import cn from 'classnames';
import React from 'react';

import ContentContainer from '../content-container/content-container';
import Footer from '../footer/footer';
import Header from '../header/header';
import MessageList from '../message-list/message-list';

import type { Layout as Props } from './layout.types';
import { Theme } from './layout.types';
import KindlyTrigger from '../kindly-trigger/kindly-trigger';

const Layout: React.FunctionComponent<React.PropsWithChildren<Props>> & {
  themes: typeof Theme;
} = ({ children, footer, header, kindlyChatKey, messageList, theme }) => (
  <div className={cn('layout', { [`layout--${theme}`]: theme })}>
    <Header {...header} />
    <main className="layout__body">{children}</main>
    {footer ? (
      <div className="layout__footer">
        <Footer {...footer} />
      </div>
    ) : null}
    <div className="layout__messages">
      <ContentContainer>
        <MessageList {...messageList} />
      </ContentContainer>
    </div>
    {kindlyChatKey ? <KindlyTrigger botKey={kindlyChatKey} /> : null}
  </div>
);

Layout.themes = Theme;

export default Layout;
